module.exports = __webpack_public_path__ + "img/WarmerStoß.9bcbcf6c.jpg";